import type { WidgetEntity } from 'src/entities/widget/WidgetEntity';
import { requireService } from 'src/packages/di';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function mapWidgetTemplates(
  widgets: TSerializedWidgetTemplate[],
  options?: { wellId: number | null },
): WidgetEntity[] {
  const mappedWidgets: WidgetEntity[] = [];
  const mapWidgetService = requireService('widgetTemplateSerializer');

  widgets.forEach((widget, index) => {
    if (!mapWidgetService.hasMapper(widget.type)) {
      console.warn(`Widget template of type "${widget.type}" is not available and was skipped.`);
      return;
    }

    const mappedWidget = mapWidgetService.map(widget, index, options);

    mappedWidgets.push(mappedWidget);
  });

  return mappedWidgets;
}

export function mapWidgetTemplate(
  widget: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null },
): WidgetEntity {
  const mapWidgetService = requireService('widgetTemplateSerializer');

  return mapWidgetService.map(widget, index, options);
}
